import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ showBackButton = false, onBackClick = null }) => {
  const { user, signOut, isAuthenticated } = useAuth();

  const handleSignOut = () => {
    if (window.confirm('Are you sure you want to sign out?')) {
      signOut();
    }
  };

  return (
    <header className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <h1>🔍 Candidate Search Portal</h1>
        <p>Find the perfect candidates using AI-powered semantic search</p>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {showBackButton && onBackClick && (
          <button
            onClick={onBackClick}
            style={{
              background: '#6f42c1',
              color: 'white',
              padding: '12px 20px',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              textDecoration: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
              whiteSpace: 'nowrap',
              transition: 'background 0.2s',
              display: 'inline-block',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            ← Back
          </button>
        )}
        
        {isAuthenticated && user && (
          <div style={styles.userSection}>
            <div style={styles.userInfo}>
              <div style={styles.userDetails}>
                <div style={styles.userName}>{user.name}</div>
                <div style={styles.userEmail}>{user.email}</div>
              </div>
            </div>
            <button
              onClick={handleSignOut}
              style={styles.signOutButton}
              onMouseOver={(e) => e.target.style.background = '#dc2626'}
              onMouseOut={(e) => e.target.style.background = '#ef4444'}
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

const styles = {
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    background: '#f8f9fa',
    padding: '8px 16px',
    borderRadius: '12px',
    border: '1px solid #e9ecef'
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  userAvatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: '2px solid #007bff'
  },
  userDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  userName: {
    fontWeight: '600',
    fontSize: '14px',
    color: '#333',
    lineHeight: '1.2'
  },
  userEmail: {
    fontSize: '12px',
    color: '#666',
    lineHeight: '1.2'
  },
  signOutButton: {
    background: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '6px 12px',
    fontSize: '12px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background 0.2s ease'
  }
};

export default Header; 